import React from "react";
import { useNavigate, useLocation } from "react-router-dom";

export const AdminSidebar: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const handleLogout = () => {
    sessionStorage.removeItem("adminLoggedIn");
    navigate("/admin/login");
  };

  const isActive = (path: string) => location.pathname === path;

  return (
    <aside className="w-64 bg-white border-r border-gray-200 flex flex-col justify-between h-full flex-shrink-0 z-10">
      <div>
        {/* Logo Section */}
        <div className="flex items-center gap-3 px-6 py-5 border-b border-gray-100">
          <div className="bg-[#E27D00] text-white font-extrabold w-8 h-8 rounded-lg flex items-center justify-center text-lg shadow-sm">
            H
          </div>
          <span className="text-[#E27D00] font-bold text-xl tracking-tight">HomeOwner</span>
        </div>

        {/* Navigation Links */}
        <nav className="px-3 space-y-1.5">
          {/* User Management */}
          <button
            onClick={() => navigate("/admin/user-management")}
            className={`w-full flex items-center justify-between px-3 py-2.5 font-medium rounded-xl text-sm transition-all ${
              isActive("/admin/user-management")
                ? "bg-[#FEF7EB] text-[#E27D00] border-r-4 border-[#E27D00]"
                : "text-gray-600 hover:bg-gray-50"
            }`}
          >
            <div className="flex items-center gap-3">
              <svg className={`w-5 h-5 ${isActive("/admin/user-management") ? "text-[#E27D00]" : "text-gray-400"}`} fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
              </svg>
              <span>User Management</span>
            </div>
          </button>

          <button
            onClick={() => navigate("/admin/feature-flags")}
            className={`w-full flex items-center justify-between px-3 py-2.5 font-medium rounded-xl text-sm transition-all ${
              isActive("/admin/feature-flags")
                ? "bg-[#FEF7EB] text-[#E27D00] border-r-4 border-[#E27D00]"
                : "text-gray-600 hover:bg-gray-50"
            }`}
          >
            <div className="flex items-center gap-3">
              <svg className={`w-5 h-5 ${isActive("/admin/feature-flags") ? "text-[#E27D00]" : "text-gray-400"}`} fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" d="M12 6V4m0 16v-2m8-6h-2M6 12H4m13.657-5.657l-1.414 1.414M7.757 16.243l-1.414 1.414m11.314 0l-1.414-1.414M7.757 7.757L6.343 6.343M12 8a4 4 0 100 8 4 4 0 000-8z" />
              </svg>
              <span>Feature Flags</span>
            </div>
          </button>

          {/* Transactions (Inactive) */}
          <button
            onClick={() => {}}
            className="w-full flex items-center justify-between px-3 py-2.5 text-gray-600 hover:bg-gray-50 font-medium rounded-xl text-sm transition-all group"
          >
            <div className="flex items-center gap-3">
              <svg className="w-5 h-5 text-gray-400 group-hover:text-gray-600" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
              </svg>
              <span>Transactions</span>
            </div>
          </button>
        </nav>
      </div>

      {/* Bottom Navigation (Settings, Support, Logout) */}
      <div className="p-3 border-t border-gray-100 space-y-1">
        {/* Settings */}
        {/* <button className="w-full flex items-center gap-3 px-3 py-2.5 text-gray-600 hover:bg-gray-50 font-medium rounded-xl text-sm transition-all group">
          <svg className="w-5 h-5 text-gray-400 group-hover:text-gray-600" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z" />
            <path strokeLinecap="round" strokeLinejoin="round" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
          </svg>
          <span>Settings</span>
        </button> */}

        {/* Logout */}
        <button
          onClick={handleLogout}
          className="w-full flex items-center gap-3 px-3 py-2.5 text-red-600 hover:bg-red-50 font-semibold rounded-xl text-sm transition-all group"
        >
          <svg className="w-5 h-5 text-red-500" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1" />
          </svg>
          <span>Log Out</span>
        </button>
      </div>
    </aside>
  );
};
